module.exports = __webpack_public_path__ + "img/bg1.35eb651e.jpg";